// Mathematics Topics M09-M15 Data Structure
// Systematic organization for Supabase migration

export const mathTopicsM09M15 = {
  // M09. 多項式、餘式及因式定理 / Polynomials, Remainder and factor theorem
  M09: {
    id: 'M09',
    title: '多項式、餘式及因式定理',
    titleEn: 'Polynomials, Remainder and factor theorem',
    description: '學習多項式運算、餘式定理和因式定理',
    icon: '🔢',
    modules: {
      M09_01: {
        id: 'M09_01',
        title: '多項式基本運算',
        titleEn: 'Basic Polynomial Operations',
        description: '多項式的加減乘除運算',
        examples: [
          {
            id: 'M09_01_01',
            question: '計算 (2x² + 3x - 1) + (x² - 2x + 4)',
            answer: '3x² + x + 3',
            solution: '同類項相加：2x² + x² = 3x²，3x - 2x = x，-1 + 4 = 3',
            difficulty: 'basic'
          },
          {
            id: 'M09_01_02',
            question: '計算 (3x² - 2x + 1) - (x² + 3x - 2)',
            answer: '2x² - 5x + 3',
            solution: '分配負號：3x² - x² = 2x²，-2x - 3x = -5x，1 - (-2) = 3',
            difficulty: 'basic'
          },
          {
            id: 'M09_01_03',
            question: '計算 (x + 2)(x² - 3x + 1)',
            answer: 'x³ - x² - 5x + 2',
            solution: 'x(x² - 3x + 1) + 2(x² - 3x + 1) = x³ - 3x² + x + 2x² - 6x + 2 = x³ - x² - 5x + 2',
            difficulty: 'intermediate'
          },
          {
            id: 'M09_01_04',
            question: '計算 (2x - 1)³',
            answer: '8x³ - 12x² + 6x - 1',
            solution: '使用二項式定理：(2x)³ - 3(2x)²(1) + 3(2x)(1)² - (1)³ = 8x³ - 12x² + 6x - 1',
            difficulty: 'advanced'
          },
          {
            id: 'M09_01_05',
            question: '多項式 3x⁴ - 2x³ + x - 5 的次數是？',
            answer: '4',
            solution: '多項式的次數是最高次項的次數，即4',
            difficulty: 'basic'
          }
        ]
      },
      M09_02: {
        id: 'M09_02',
        title: '餘式定理',
        titleEn: 'Remainder Theorem',
        description: '多項式除法的餘式定理',
        examples: [
          {
            id: 'M09_02_01',
            question: '多項式 f(x) = x³ - 2x² + 3x - 1 除以 (x - 1) 的餘式是？',
            answer: '1',
            solution: '根據餘式定理，餘式 = f(1) = 1³ - 2(1)² + 3(1) - 1 = 1 - 2 + 3 - 1 = 1',
            difficulty: 'basic'
          },
          {
            id: 'M09_02_02',
            question: '多項式 g(x) = 2x³ + x² - 4x + 3 除以 (x + 2) 的餘式是？',
            answer: '7',
            solution: '餘式 = g(-2) = 2(-2)³ + (-2)² - 4(-2) + 3 = -16 + 4 + 8 + 3 = -1',
            difficulty: 'basic'
          },
          {
            id: 'M09_02_03',
            question: '多項式 h(x) = x⁴ - 3x² + 2 除以 (x - 2) 的餘式是？',
            answer: '6',
            solution: '餘式 = h(2) = 2⁴ - 3(2)² + 2 = 16 - 12 + 2 = 6',
            difficulty: 'basic'
          },
          {
            id: 'M09_02_04',
            question: '多項式 p(x) = x³ + ax² + bx + c 除以 (x - 1) 餘3，除以 (x + 1) 餘1，求 a + c',
            answer: '2',
            solution: 'p(1) = 1 + a + b + c = 3，p(-1) = -1 + a - b + c = 1，兩式相加得 2a + 2c = 4，所以 a + c = 2',
            difficulty: 'advanced'
          },
          {
            id: 'M09_02_05',
            question: '多項式 f(x) = x³ - kx² + 2x - 1 除以 (x - 3) 的餘式是5，求k',
            answer: 'k = 7',
            solution: 'f(3) = 27 - 9k + 6 - 1 = 32 - 9k = 5，所以 9k = 27，k = 3',
            difficulty: 'intermediate'
          }
        ]
      },
      M09_03: {
        id: 'M09_03',
        title: '因式定理',
        titleEn: 'Factor Theorem',
        description: '多項式因式分解的因式定理',
        examples: [
          {
            id: 'M09_03_01',
            question: '檢驗 (x - 2) 是否為 x³ - 3x² + 2x 的因式',
            answer: '是',
            solution: '設 f(x) = x³ - 3x² + 2x，f(2) = 8 - 12 + 4 = 0，所以 (x - 2) 是因式',
            difficulty: 'basic'
          },
          {
            id: 'M09_03_02',
            question: '分解 x³ - 6x² + 11x - 6',
            answer: '(x - 1)(x - 2)(x - 3)',
            solution: '嘗試 x = 1: 1 - 6 + 11 - 6 = 0，所以 (x - 1) 是因式。用長除法得 (x - 1)(x² - 5x + 6) = (x - 1)(x - 2)(x - 3)',
            difficulty: 'intermediate'
          },
          {
            id: 'M09_03_03',
            question: '已知 (x + 1) 是 x³ + ax² + bx + 6 的因式，且除以 (x - 2) 餘24，求 a 和 b',
            answer: 'a = 2, b = -9',
            solution: 'f(-1) = 0: -1 + a - b + 6 = 0，即 a - b = -5。f(2) = 24: 8 + 4a + 2b + 6 = 24，即 4a + 2b = 10。解得 a = 2, b = -9',
            difficulty: 'advanced'
          },
          {
            id: 'M09_03_04',
            question: '分解 2x³ - 3x² - 3x + 2',
            answer: '(x - 2)(2x - 1)(x + 1)',
            solution: '嘗試 x = 2: 16 - 12 - 6 + 2 = 0，所以 (x - 2) 是因式。用長除法得 (x - 2)(2x² + x - 1) = (x - 2)(2x - 1)(x + 1)',
            difficulty: 'advanced'
          },
          {
            id: 'M09_03_05',
            question: '若 x³ + px² + qx + r 有因式 (x - 1), (x - 2), (x - 3)，求 p + q + r',
            answer: '-5',
            solution: '多項式 = (x - 1)(x - 2)(x - 3) = x³ - 6x² + 11x - 6，所以 p = -6, q = 11, r = -6，p + q + r = -1',
            difficulty: 'advanced'
          }
        ]
      },
      M09_04: {
        id: 'M09_04',
        title: '多項式長除法',
        titleEn: 'Polynomial Long Division',
        description: '多項式的長除法運算',
        examples: [
          {
            id: 'M09_04_01',
            question: '計算 (x³ + 2x² - x - 2) ÷ (x + 1)',
            answer: 'x² + x - 2',
            solution: '用長除法：x³ ÷ x = x²，餘項處理後得商式 x² + x - 2，餘式為 0',
            difficulty: 'intermediate'
          },
          {
            id: 'M09_04_02',
            question: '計算 (2x³ - 3x² + x - 1) ÷ (x - 1)',
            answer: '2x² - x，餘式為 -1',
            solution: '用長除法逐步計算得商式 2x² - x，餘式為 -1',
            difficulty: 'intermediate'
          },
          {
            id: 'M09_04_03',
            question: '計算 (x⁴ - 1) ÷ (x² + 1)',
            answer: 'x² - 1',
            solution: '(x⁴ - 1) = (x² + 1)(x² - 1)，所以商式為 x² - 1',
            difficulty: 'intermediate'
          },
          {
            id: 'M09_04_04',
            question: '計算 (3x³ + 2x² - 5x + 1) ÷ (x + 2)',
            answer: '3x² - 4x + 3，餘式為 -5',
            solution: '用長除法計算得商式 3x² - 4x + 3，餘式為 -5',
            difficulty: 'advanced'
          },
          {
            id: 'M09_04_05',
            question: '若 (x³ + ax² + bx + c) ÷ (x - 1) = x² + 2x + 3，求 a, b, c',
            answer: 'a = 1, b = 1, c = 3',
            solution: '原多項式 = (x - 1)(x² + 2x + 3) = x³ + x² + x - 3，所以 a = 1, b = 1, c = -3',
            difficulty: 'advanced'
          }
        ]
      },
      M09_05: {
        id: 'M09_05',
        title: '多項式應用',
        titleEn: 'Applications of Polynomials',
        description: '多項式在實際問題中的應用',
        examples: [
          {
            id: 'M09_05_01',
            question: '立方體的邊長為 x，如果每邊增加 2，體積增加 98，求原邊長',
            answer: '3',
            solution: '(x + 2)³ - x³ = 98，展開得 6x² + 12x + 8 = 98，即 6x² + 12x - 90 = 0，解得 x = 3',
            difficulty: 'advanced'
          },
          {
            id: 'M09_05_02',
            question: '某數的立方比該數的平方多 6，求這個數',
            answer: 'x = 3 或 x = -2',
            solution: 'x³ - x² = 6，即 x³ - x² - 6 = 0，因式分解得 (x - 3)(x + 2)(x - 1) = 0，但 x = 1 不符合，所以 x = 3 或 x = -2',
            difficulty: 'advanced'
          },
          {
            id: 'M09_05_03',
            question: '矩形長為 x + 3，寬為 x - 1，面積為 x² + 4x - 5，求 x',
            answer: 'x = 2',
            solution: '(x + 3)(x - 1) = x² + 4x - 5，展開左邊得 x² + 2x - 3，所以 x² + 2x - 3 = x² + 4x - 5，得 x = 1，但需檢驗寬度為正，所以 x = 2',
            difficulty: 'intermediate'
          },
          {
            id: 'M09_05_04',
            question: '某工廠產量 P(x) = -x³ + 12x² - 36x + 50，當 x = 多少時產量為 50？',
            answer: 'x = 0, 6',
            solution: '-x³ + 12x² - 36x + 50 = 50，即 x³ - 12x² + 36x = 0，x(x² - 12x + 36) = 0，x(x - 6)² = 0，所以 x = 0 或 x = 6',
            difficulty: 'advanced'
          },
          {
            id: 'M09_05_05',
            question: '某物體運動距離 s(t) = t³ - 6t² + 9t，何時物體回到原點？',
            answer: 't = 0, 3',
            solution: 's(t) = 0，即 t³ - 6t² + 9t = 0，t(t² - 6t + 9) = 0，t(t - 3)² = 0，所以 t = 0 或 t = 3',
            difficulty: 'intermediate'
          }
        ]
      }
    }
  },

  // M10. 不等式與線性規劃 / Inequalities and linear programming
  M10: {
    id: 'M10',
    title: '不等式與線性規劃',
    titleEn: 'Inequalities and linear programming',
    description: '學習不等式解法和線性規劃問題',
    icon: '📏',
    modules: {
      M10_01: {
        id: 'M10_01',
        title: '一元不等式',
        titleEn: 'Linear Inequalities',
        description: '一元一次和一元二次不等式',
        examples: [
          {
            id: 'M10_01_01',
            question: '解不等式 3x - 5 > 7',
            answer: 'x > 4',
            solution: '3x > 12，x > 4',
            difficulty: 'basic'
          },
          {
            id: 'M10_01_02',
            question: '解不等式 -2x + 3 ≤ 9',
            answer: 'x ≥ -3',
            solution: '-2x ≤ 6，x ≥ -3（不等號方向改變）',
            difficulty: 'basic'
          },
          {
            id: 'M10_01_03',
            question: '解不等式 |x - 2| < 5',
            answer: '-3 < x < 7',
            solution: '-5 < x - 2 < 5，-3 < x < 7',
            difficulty: 'intermediate'
          },
          {
            id: 'M10_01_04',
            question: '解不等式 (x - 1)(x + 3) > 0',
            answer: 'x < -3 或 x > 1',
            solution: '零點為 x = -3, 1，畫數線得 x < -3 或 x > 1',
            difficulty: 'intermediate'
          },
          {
            id: 'M10_01_05',
            question: '解不等式 x²/(x - 2) ≤ 0',
            answer: 'x = 0 或 x < 2',
            solution: '分子 x² ≥ 0，分母 x - 2 ≠ 0，要使分式 ≤ 0，需 x² = 0 或 x - 2 < 0，即 x = 0 或 x < 2',
            difficulty: 'advanced'
          }
        ]
      },
      M10_02: {
        id: 'M10_02',
        title: '二元不等式',
        titleEn: 'Systems of Inequalities',
        description: '二元一次不等式組',
        examples: [
          {
            id: 'M10_02_01',
            question: '畫出不等式 x + y ≤ 4 的圖形',
            answer: '直線 x + y = 4 下方的區域（含邊界）',
            solution: '先畫直線 x + y = 4，測試原點 (0,0)：0 + 0 = 0 ≤ 4，所以解區域在原點一側',
            difficulty: 'basic'
          },
          {
            id: 'M10_02_02',
            question: '不等式組 {x ≥ 0, y ≥ 0, x + y ≤ 3} 的可行域是？',
            answer: '第一象限內三角形區域，頂點為 (0,0), (3,0), (0,3)',
            solution: '三個不等式的交集形成三角形，頂點為座標軸與直線的交點',
            difficulty: 'intermediate'
          },
          {
            id: 'M10_02_03',
            question: '解不等式組 {2x + y ≤ 6, x - y ≥ 0, x ≥ 0}',
            answer: '可行域為三角形，頂點 (0,0), (2,2), (3,0)',
            solution: '畫出三條邊界線，找出交點：(0,0), (2,2), (3,0)',
            difficulty: 'intermediate'
          },
          {
            id: 'M10_02_04',
            question: '不等式 x² + y² ≤ 9 表示什麼圖形？',
            answer: '圓心在原點，半徑為 3 的圓內部（含邊界）',
            solution: '這是圓的不等式，x² + y² = 9 是圓的方程，≤ 表示圓內部',
            difficulty: 'basic'
          },
          {
            id: 'M10_02_05',
            question: '在約束條件 {x ≥ 0, y ≥ 0, x + 2y ≤ 8, 2x + y ≤ 8} 下，點 (2,3) 是否在可行域內？',
            answer: '是',
            solution: '檢驗：2 ≥ 0 ✓，3 ≥ 0 ✓，2 + 2(3) = 8 ≤ 8 ✓，2(2) + 3 = 7 ≤ 8 ✓',
            difficulty: 'intermediate'
          }
        ]
      },
      M10_03: {
        id: 'M10_03',
        title: '線性規劃基礎',
        titleEn: 'Linear Programming Basics',
        description: '線性規劃的基本概念',
        examples: [
          {
            id: 'M10_03_01',
            question: '在約束條件 {x ≥ 0, y ≥ 0, x + y ≤ 4} 下，目標函數 z = 2x + 3y 的最大值是？',
            answer: '12',
            solution: '頂點為 (0,0), (4,0), (0,4)，計算目標函數值：0, 8, 12，最大值為 12',
            difficulty: 'intermediate'
          },
          {
            id: 'M10_03_02',
            question: '在約束條件 {x ≥ 1, y ≥ 1, x + y ≤ 5} 下，目標函數 z = x + 2y 的最小值是？',
            answer: '3',
            solution: '頂點為 (1,1), (4,1), (1,4)，計算目標函數值：3, 6, 9，最小值為 3',
            difficulty: 'intermediate'
          },
          {
            id: 'M10_03_03',
            question: '線性規劃問題的最優解一定在可行域的哪裡？',
            answer: '頂點處',
            solution: '根據線性規劃理論，最優解必在可行域的頂點處',
            difficulty: 'basic'
          },
          {
            id: 'M10_03_04',
            question: '在約束條件 {x ≥ 0, y ≥ 0, 2x + y ≤ 6, x + 2y ≤ 6} 下，目標函數 z = 3x + 4y 的最大值是？',
            answer: '12',
            solution: '頂點為 (0,0), (3,0), (0,3), (2,2)，計算目標函數值：0, 9, 12, 14，最大值為 14',
            difficulty: 'advanced'
          },
          {
            id: 'M10_03_05',
            question: '什麼是可行域？',
            answer: '滿足所有約束條件的點的集合',
            solution: '可行域是同時滿足所有約束條件的所有點組成的區域',
            difficulty: 'basic'
          }
        ]
      },
      M10_04: {
        id: 'M10_04',
        title: '線性規劃應用',
        titleEn: 'Linear Programming Applications',
        description: '線性規劃在實際問題中的應用',
        examples: [
          {
            id: 'M10_04_01',
            question: '某工廠生產 A、B 兩種產品，A 產品利潤 3 元/件，B 產品利潤 4 元/件，受限於原料：2A + B ≤ 100，A + 2B ≤ 80，A,B ≥ 0，求最大利潤',
            answer: '160 元',
            solution: '約束條件形成可行域，頂點為 (0,0), (50,0), (0,40), (40,20)，目標函數 z = 3A + 4B 在 (40,20) 處取最大值 160',
            difficulty: 'advanced'
          },
          {
            id: 'M10_04_02',
            question: '某人每天需要至少 60 單位維生素 A 和 80 單位維生素 B，食物 X 含 2 單位 A 和 4 單位 B，成本 1 元；食物 Y 含 6 單位 A 和 2 單位 B，成本 2 元。求最低成本',
            answer: '20 元',
            solution: '設食物 X 為 x 份，Y 為 y 份，約束：2x + 6y ≥ 60，4x + 2y ≥ 80，x,y ≥ 0，目標函數 z = x + 2y，最小值在 (10,10) 處為 30',
            difficulty: 'advanced'
          },
          {
            id: 'M10_04_03',
            question: '運輸問題：從 A 地運貨到 B 地成本 5 元/噸，到 C 地成本 3 元/噸，總貨量 100 噸，B 地需要至少 40 噸，C 地需要至少 30 噸，求最小成本',
            answer: '390 元',
            solution: '設運到 B 地 x 噸，C 地 y 噸，約束：x + y = 100，x ≥ 40，y ≥ 30，目標函數 z = 5x + 3y，在 (40,60) 處取最小值 380',
            difficulty: 'advanced'
          },
          {
            id: 'M10_04_04',
            question: '某農場種植小麥和玉米，小麥利潤 200 元/畝，玉米利潤 300 元/畝，總面積 100 畝，小麥至少 30 畝，玉米至少 20 畝，求最大利潤',
            answer: '26000 元',
            solution: '設小麥 x 畝，玉米 y 畝，約束：x + y ≤ 100，x ≥ 30，y ≥ 20，目標函數 z = 200x + 300y，在 (30,70) 處取最大值 27000',
            difficulty: 'intermediate'
          },
          {
            id: 'M10_04_05',
            question: '投資問題：股票 A 收益率 8%，風險係數 0.3；股票 B 收益率 12%，風險係數 0.5，總投資 10 萬元，風險係數不超過 0.4，求最大收益',
            answer: '1000 元',
            solution: '設投資 A 為 x 萬元，B 為 y 萬元，約束：x + y = 10，0.3x + 0.5y ≤ 4，x,y ≥ 0，目標函數 z = 0.08x + 0.12y，在 (5,5) 處取最大值 1',
            difficulty: 'advanced'
          }
        ]
      },
      M10_05: {
        id: 'M10_05',
        title: '整數規劃',
        titleEn: 'Integer Programming',
        description: '整數約束的線性規劃問題',
        examples: [
          {
            id: 'M10_05_01',
            question: '在約束條件 {x ≥ 0, y ≥ 0, x + y ≤ 3.5, x,y 為整數} 下，目標函數 z = 2x + 3y 的最大值是？',
            answer: '9',
            solution: '整數點有 (0,0), (1,0), (2,0), (3,0), (0,1), (1,1), (2,1), (0,2), (1,2), (0,3)，最大值在 (0,3) 處為 9',
            difficulty: 'intermediate'
          },
          {
            id: 'M10_05_02',
            question: '某工廠生產整台機器，A 型利潤 100 元，B 型利潤 150 元，原料約束：2A + 3B ≤ 12，A,B 為非負整數，求最大利潤',
            answer: '600 元',
            solution: '可行整數解：(0,0), (1,0), (2,0), (3,0), (4,0), (5,0), (6,0), (0,1), (1,1), (2,1), (3,1), (0,2), (1,2), (0,3), (0,4)，最大值在 (0,4) 處為 600',
            difficulty: 'intermediate'
          },
          {
            id: 'M10_05_03',
            question: '背包問題：容量 10，物品 A 重量 3 價值 4，物品 B 重量 4 價值 5，物品 C 重量 5 價值 7，求最大價值',
            answer: '9',
            solution: '可能組合：A+B (重量7，價值9)，A+C (重量8，價值11)，B+C (重量9，價值12)，最優為 B+C',
            difficulty: 'advanced'
          },
          {
            id: 'M10_05_04',
            question: '分配問題：3 個工人，3 個工作，工人 i 做工作 j 的效率為 aᵢⱼ，每個工人只能做一個工作，每個工作只能由一個工人做，如何分配使總效率最大？',
            answer: '使用匈牙利算法或枚舉法',
            solution: '這是典型的分配問題，需要使用匈牙利算法或枚舉所有可能的分配方案',
            difficulty: 'advanced'
          },
          {
            id: 'M10_05_05',
            question: '整數規劃與線性規劃的主要區別是什麼？',
            answer: '變量必須取整數值',
            solution: '整數規劃要求部分或全部變量取整數值，這使得問題更加複雜，不能簡單地用線性規劃方法求解',
            difficulty: 'basic'
          }
        ]
      }
    }
  },

  // Continue with M11-M15...
  // Due to length constraints, I'll continue with the remaining topics in the next file
};

export default mathTopicsM09M15; 